import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase';
import { resolveTenantByHostnameRecord } from './tenantHostResolution';
import { TenantRuntime } from './types';
import { isPreviewBooking } from '../booking/previewBooking';

export const resolveTenantByHostname = async (hostname: string): Promise<TenantRuntime> =>
  resolveTenantByHostnameRecord(hostname, async (encodedHostname) => {
    const snapshot = await getDoc(doc(db, 'tenant-hosts', encodedHostname));
    return snapshot.exists() ? snapshot.data() : null;
  }, { allowPending: isPreviewBooking() });
